import z from "zod";

export const StoredPromptIdParamsSchema = z.object({
  id: z.string(),
});

const GrantsSchema = z.record(z.string(), z.boolean());

export const StoredPromptSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  prompt: z.string(),
  richText: z.string().nullable().optional(),
  isStarred: z.boolean().optional().default(false),
  tenantId: z.string(),
  organizationId: z.string(),
  workspaceId: z.string(),
  projectId: z.string(),
  createdBy: z.string(),
  createdAt: z.string(),
  modifiedBy: z.string(),
  modifiedAt: z.string(),
  isArchived: z.boolean().optional(),
  grants: GrantsSchema.optional(),
});
export type StoredPrompt = z.infer<typeof StoredPromptSchema>;

export const CreateStoredPromptInputSchema = z.object({
  name: z.string(),
  description: z.string(),
  prompt: z.string(),
  richText: z.string().optional(),
});

export const UpdateStoredPromptInputSchema = z.object({
  name: z.string(),
  description: z.string(),
  prompt: z.string(),
  richText: z.string().optional(),
});

export const StarStoredPromptInputSchema = z.object({
  isStarred: z.boolean(),
});

export const StoredPromptsSyncSchema = z.object({
  prompts: z.record(z.string(), StoredPromptSchema),
});
